import React, { useEffect, useState } from 'react'
import './styles.scss'

interface ServerNoticeProps {
  open: boolean
}

const ServerNotice: React.FC<ServerNoticeProps> = ({ open }) => {
  const [openNotice, setOpenNotice] = useState(false)
  useEffect(() => {
    setOpenNotice(open)
    return () => setOpenNotice(false)
  }, [open])

  const handleClose = () => {
    setOpenNotice(() => false)
  }

  if (!openNotice) return null

  return (
    <div className={'notice-warn'}>
      <article className="notice-warn-content">
        <span style={{ color: 'red', fontWeight: 'bold' }}>Note:</span>I`m using
        free instance for storing data, so API requests will spin down with
        inactivity, which can delay requests by 50 seconds or more.
        <button className="close" onClick={handleClose}>
          Understand
        </button>
      </article>
    </div>
  )
}

export default ServerNotice
